import { GenericForm } from '@neo/blocks/forms/generic-form'
import { useEffect, useMemo } from 'react'
import { useSecretVariableMutation } from '../queries'
import { formFields, type SecretVariableForm } from './secrets.config'

interface SecretVariableFormProps {
  defaultValues?: Partial<SecretVariableForm>
  onSuccess?: () => void
  setIsPending?: (isPending: boolean) => void
}

export const SecretVariableFormComponent = ({
  defaultValues,
  onSuccess,
  setIsPending,
}: SecretVariableFormProps) => {
  const { mutate, isPending } = useSecretVariableMutation()
  const initialValues = useMemo(
    () => ({
      id: defaultValues?.id,
      name: defaultValues?.name || '',
      value: '',
      description: defaultValues?.description || '',
    }),
    [defaultValues],
  )

  useEffect(() => {
    setIsPending?.(isPending)
  }, [isPending, setIsPending])

  return (
    <GenericForm
      id="secret-variable-form"
      defaultValues={initialValues}
      className="gap-4"
      includeSubmitButton={false}
      fields={formFields}
      onSubmit={(values) => {
        mutate(
          { ...values, id: defaultValues?.id, description: values.description || '' },
          { onSuccess },
        )
      }}
    />
  )
}
